<ng-template #userItemTemplate let-item="item">
  <ca-clickable-link
    class="mt-auto mb-auto truncate-text"
    [innerHtml]="item.username"
    [targetLink]="[item.id]"
    [showTooltipIfTruncated]="true"></ca-clickable-link>
</ng-template>

<table mat-table [dataSource]="dataSource" class="fixed-table table-100">
  <ng-container *ngFor="let gridColumn of gridColumns">
    <ng-container
      *ngIf="
        gridColumn.columnName !== 'username' &&
        gridColumn.columnName !== 'icons' &&
        gridColumn.columnName !== 'select' &&
        gridColumn.columnName !== 'departmentName'
      "
      matColumnDef="{{ gridColumn.columnName }}">
      <th
        mat-header-cell
        *matHeaderCellDef
        [style.width]="gridColumn.width"
        [style.minWidth]="gridColumn.minWidth || gridColumn.width"
        [style.maxWidth]="gridColumn.maxWidth || gridColumn.width"
        container="body"
        [ngbTooltip]="gridColumn.tooltip">
        {{ gridColumn.header }}
      </th>
      <td
        mat-cell
        *matCellDef="let user"
        [style.width]="gridColumn.width"
        [style.minWidth]="gridColumn.minWidth || gridColumn.width"
        [style.maxWidth]="gridColumn.maxWidth || gridColumn.width"
        [innerHtml]="user | objectparser : gridColumn"
        container="body"
        [ngbTooltip]="user | objectparser : gridColumn"
        showTooltipIfTruncated></td>
    </ng-container>
    <ng-container
      *ngIf="gridColumn.columnName === 'select'"
      matColumnDef="{{ gridColumn.columnName }}">
      <th
        [style.width]="gridColumn.width"
        [style.minWidth]="gridColumn.minWidth || gridColumn.width"
        [style.maxWidth]="gridColumn.maxWidth || gridColumn.width"
        mat-header-cell
        *matHeaderCellDef>
        <mat-checkbox
          *ngIf="totalSelectableCount > 0"
          (change)="$event ? onToggleAll($event) : null"
          [checked]="isAllSelected()"
          [indeterminate]="isPageIndeterminate()"></mat-checkbox>
      </th>
      <td
        [style.width]="gridColumn.width"
        [style.minWidth]="gridColumn.minWidth || gridColumn.width"
        [style.maxWidth]="gridColumn.maxWidth || gridColumn.width"
        mat-cell
        *matCellDef="let row"
        (dblclick)="$event.stopPropagation()">
        <mat-checkbox
          *ngIf="isRowSelectable(row)"
          (click)="$event.stopPropagation()"
          (change)="onRowChecked(row)"
          [checked]="isRowSelected(row)"></mat-checkbox>
      </td>
    </ng-container>
    <ng-container
      *ngIf="gridColumn.columnName === 'icons'"
      matColumnDef="{{ gridColumn.columnName }}">
      <th
        mat-header-cell
        *matHeaderCellDef
        [style.width]="gridColumn.width"
        [style.minWidth]="gridColumn.minWidth || gridColumn.width"
        [style.maxWidth]="gridColumn.maxWidth || gridColumn.width">
        {{ gridColumn.header }}
      </th>
      <td
        mat-cell
        *matCellDef="let user"
        [style.width]="gridColumn.width"
        [style.minWidth]="gridColumn.minWidth || gridColumn.width"
        [style.maxWidth]="gridColumn.maxWidth || gridColumn.width"></td>
    </ng-container>
    <ng-container
      *ngIf="gridColumn.columnName === 'username'"
      matColumnDef="{{ gridColumn.columnName }}">
      <th
        mat-header-cell
        *matHeaderCellDef
        [style.width]="gridColumn.width"
        [style.minWidth]="gridColumn.minWidth || gridColumn.width"
        [style.maxWidth]="gridColumn.maxWidth || gridColumn.width">
        {{ gridColumn.header }}
      </th>
      <td
        mat-cell
        *matCellDef="let user"
        [style.width]="gridColumn.width"
        [style.minWidth]="gridColumn.minWidth || gridColumn.width"
        [style.maxWidth]="gridColumn.maxWidth || gridColumn.width"
        container="body">
        <ca-user-identity
          [id]="user.id"
          [name]="user.name"
          [surname]="user.surname"
          [item]="user"
          [itemTemplate]="userItemTemplate"></ca-user-identity>
      </td>
    </ng-container>
    <ng-container
      *ngIf="gridColumn.columnName === 'departmentName'"
      matColumnDef="{{ gridColumn.columnName }}">
      <th
        mat-header-cell
        *matHeaderCellDef
        [style.width]="gridColumn.width"
        [style.minWidth]="gridColumn.minWidth || gridColumn.width"
        [style.maxWidth]="gridColumn.maxWidth || gridColumn.width"
        container="body"
        [ngbTooltip]="gridColumn.tooltip">
        {{ gridColumn.header }}
      </th>
      <td
        mat-cell
        [ngClass]="gridColumn.cellClass"
        *matCellDef="let user"
        [style.width]="gridColumn.width"
        [style.minWidth]="gridColumn.minWidth || gridColumn.width"
        [style.maxWidth]="gridColumn.maxWidth || gridColumn.width"
        class="selectable-cell department-cell"
        container="body">
        <div
          [cdkCopyToClipboard]="user.departmentHierarchyName || user.department?.name"
          (click)="copyToClipboard()"
          class="truncate-text user-copy-to-clipboard department-hierarchy-cell"
          title="{{ '::CopytoClipboard' | abpLocalization }}"
          #tooltip="ngbTooltip"
          [ngbTooltip]="departmentHierarchyTemplate"
          container="body"
          triggers="manual"
          (mouseenter)="showDepartmentTooltip(user, tooltip)"
          (mouseleave)="tooltip.close()">
          {{ user.departmentHierarchyName || user.department?.name }}
        </div>
      </td>
    </ng-container>
  </ng-container>
  <!-- Info column -->
  <ng-container matColumnDef="info">
    <td
      mat-footer-cell
      *matFooterCellDef
      style="text-align: left"
      [attr.colspan]="displayedColumns.length">
      <span>
        <mat-paginator
          style="display: flex; justify-content: left"
          (page)="pageChanged($event)"
          [pageIndex]="currentPage"
          [length]="totalCount"
          [pageSize]="pageSize"
          class="paginator"
          hidePageSize
          showFirstLastButtons></mat-paginator>
      </span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr
    mat-row
    class="user-row-{{ myRowData.id }}"
    (dblclick)="onRowDoubleClick($event, myRowData.id)"
    *matRowDef="let myRowData; columns: displayedColumns"></tr>
  <tr mat-footer-row *matFooterRowDef="['info']; sticky: true"></tr>
</table>

<ng-template
  #departmentHierarchyTemplate
  let-departmentId="departmentId"
  let-departmentName="departmentName">
  <div
    *ngIf="isDepartmentHierarchyLoading; else loadedBlock"
    class="d-flex justify-content-center p-2">
    <mat-progress-spinner diameter="20" mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>
  <ng-template #loadedBlock>
    <ng-container *ngIf="departmentHierarchyMap.get(departmentId) as value; else errorBlock">
      <div class="dept-tree-content">
        <div
          *ngFor="let part of value.split('\\'); let last = last"
          class="dept-tree-item"
          [class.is-last]="last">
          <span class="conn"></span>
          <span class="node-icon"><i class="far fa-building"></i></span>
          <span class="label">{{ part }}</span>
        </div>
      </div>
    </ng-container>
    <ng-template #errorBlock>
      <div class="dept-tree-content">
        <div class="dept-tree-item root is-last">
          <span class="node-icon" aria-hidden="true"><i class="far fa-building"></i></span>
          <span class="label">{{ departmentName }}</span>
        </div>
        <div class="text-danger small mt-1">
          {{ 'Department::DepartmentPathNotFound' | abpLocalization }}
        </div>
      </div>
    </ng-template>
  </ng-template>
</ng-template>
